import axios from "axios";
import { apiRequest } from "@/services/api/apiClient.js";
import internalApi from "@/services/api/internalApi.js";
import {PoolEntity} from "@/entities/PoolEntity.js";
import {ContractEntity} from "@/entities/ContractEntity.js";

const entity = new ContractEntity();

export async function getContracts({ page = 1, limit = 10, ...filters }) {
    return apiRequest({
        client: window.API_CONTRACT,
        method: "get",
        url: "/contract",
        params: { page, limit, ...filters },
    });
}

export async function getCities(query) {
    return apiRequest({
        client: window.API_CONTRACT,
        method: "get",
        url: `/city?${query}`,
    });
}

export async function listClassifications(name) {
    return apiRequest({
        client: window.API_AUTH,
        method: "get",
        url: "/classification",
        params: { name },
    });
}

export async function getContractById({id}) {
    return apiRequest({
        client: window.API_CONTRACT,
        method: "get",
        url: entity.getUrl(entity.endpoints.get, { id }),
    });
}

export async function getContractItems({id}) {
    return apiRequest({
        client: window.API_CONTRACT,
        method: "get",
        url: entity.getUrl(entity.endpoints.getItems, { id: id }),
    });
}
